export const NAVBAR_ID = "new_navbar";

export const EYE_IMAGE_ID = 'eye_image';
export const SPIRAL_IMAGE_ID = 'spiral_image';
export const H1_ID = 'h1_text';

export const FULL_WEBSITE_BG = "full_website_bg";